<template>
  <div>
    <div>
      {{title}}
      <el-select v-model="prov" value-key="value" placeholder="请选择" @change="provChange" style="width: 6.4em;">
        <el-option v-for="item in provArray" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      -
      <el-select v-model="city" value-key="value" placeholder="请选择" @change="cityChange" style="width: 11em;" multiple collapse-tags>
        <el-option v-for="item in cityArray" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import { areaList } from "@/api/url";
import { getFormData } from "@/api/api";

export default {
  name: "Area",
  props: {
    title: {
      type: String,
      default: function() {
        return '地区:'
      }
    },
    reset: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      provArray: [
        {label: '全国', value: ''}
      ],
      cityArray: [
        {label: '不限', value: '不限'}
      ],
      prov: '',
      city: ['不限'],
      areaList: [],
    }
  },
  watch: {
    reset() {
      this.prov = '';
      this.city = ['不限'];
      let areaObj = {
        prov: this.prov,
        city: this.city
      }
      this.$emit('areaChang', areaObj)
    }
  },
  methods: {
    provChange(e) {
      this.cityArray = [
        {label: '不限', value: '不限'}
      ]
      this.city = ['不限']
      for(let i=0; i<this.areaList.length; i++) {
        if ( this.areaList[i].nativeCode == e && this.areaList[i].province != '海外' ) {
          let arr = []
          this.areaList[i].cityList.map(item => {
            let obj = {}
            obj.label = item.city
            obj.value = item.nativeCode
            arr.push(obj)
          })
          this.cityArray = this.cityArray.concat(arr)
        }
      }
      let areaObj = {
        prov: this.prov,
        city: this.city
      }
      this.$emit('areaChang', areaObj)
    },
    cityChange() {
      if(this.city[0] == '不限') {
        this.city.splice(0, 1)
      }else if(this.city.indexOf('不限') > -1) {
        this.city = ['不限']
      }
      let areaObj = {
        prov: this.prov,
        city: this.city
      }
      this.$emit('areaChang', areaObj)
    },
    getAreaList () {
      getFormData( areaList ).then((data) => {
        if (data.code == 200) {
          this.areaList = data.data
          let arr = []
          this.areaList.map(item => {
            let obj = {}
            if(item.province != '海外') {
              obj.label = item.province
              obj.value = item.nativeCode
              arr.push(obj)
            }
          })
          this.provArray = this.provArray.concat(arr)
        }
      })
    }
  },
  mounted() {
    this.getAreaList()
  }
}
</script>

<style scoped>

</style>
